import { useEffect, useState } from "react";
import { IPanelUbicacionEliminar } from "./PanelUbicacionEliminar";
import { codigosRespuesta, IResponseApiFluent } from "../../../../interfaces/base/IResponse";
import { LugarMovilizacionService } from "../../../../services/movilizacion/LugarMovilizacionService";

const UseUbicacionEliminar = (props: IPanelUbicacionEliminar) => {
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false)
    const [hiddenFooter, setHiddenFooter] = useState<boolean>(false)
    const initial: string = ""
    const [request, setRequest] = useState<string>(initial)

    const deleteUbicacion = () => {
        setLoading(true)
        setHiddenFooter(true)
        LugarMovilizacionService.EliminarEstadoLugarMovilizacion(request)
            .then((res) => {
                if (res.status == 200) {
                    setStatus(200)
                    setMensaje(res.data.mensaje);
                    setTimeout(() => {
                        props.reload?.();
                        reset()
                    }, 3000)
                } else {
                    setStatus(500)
                }
                setLoading(false)
                setHiddenFooter(false)
            })
            .catch((e) => {
                if (
                    e.response?.data &&
                    'type' in e.response.data &&
                    'title' in e.response.data &&
                    'status' in e.response.data &&
                    'instance' in e.response.data &&
                    'errors' in e.response.data
                ) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    setMensaje(mensajeError);
                    // setTimeout(() => {
                    //     props.reload?.();
                    //     reset()
                    // }, 3000)
                } else {
                    setMensaje("Error Inesperado");
                    
                }
                setStatus(500);
                setLoading(false);
            })
    }

    const reset = () => {
        setMensaje("")
        setRequest(initial)
        setStatus(0)
        props.onDismiss()
    }

    useEffect(() => {
        if (props.isOpen) {
            if (props.ubicacionData.lugarMovilizacionId != initial) {
                setRequest(props.ubicacionData.lugarMovilizacionId)
            }
        }
    }, [props.ubicacionData, props.isOpen])
    


    return { request, deleteUbicacion, loading, reset, mensaje, status, hiddenFooter }
}

export { UseUbicacionEliminar }